import { Component, ElementRef, EventEmitter, Input, OnInit, Output, TemplateRef, ViewChild } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { SettlementsService } from 'src/app/services/settlements.service';
import { SettlementUser } from 'src/app/models/settlement-user.model';
import { ToastrService } from 'ngx-toastr';
import { Settlement } from 'src/app/models/settlement.model';
import { NgbModal, NgbModalRef } from '@ng-bootstrap/ng-bootstrap';


@Component({
  selector: 'app-users-form',
  template: `
    <ng-template #usersForm let-modal>
      <div class="modal-header">
        <h5 class="modal-title">{{ user ? 'Editar usuario' : 'Agregar nuevo usuario' }}</h5>
        <button type="button" class="btn-close" aria-label="Close" (click)="modal.dismiss()"></button>
      </div>
      <div class="modal-body">
        <form [formGroup]="userForm" (ngSubmit)="onSubmit()">
          <div class="form-group required mb-3" *ngIf="!user">
            <label for="name" class="form-label">Nombre</label>
            <input 
              type="name"
              class="form-control"
              id="name"
              formControlName="name"
              [ngClass]="{'is-invalid': submitted && f['name'].errors}"
            >
            <div class="invalid-feedback" *ngIf="submitted && f['name'].errors">
              <div *ngIf="f['name'].errors['required']">Nombre es requerido</div>
              <div *ngIf="f['name'].errors['name']">Nombre debe ser válido</div>
            </div>
          </div>

          <div class="form-group required mb-3" *ngIf="!user">
            <label for="last_name" class="form-label">Apellido</label>
            <input 
              type="last_name"
              class="form-control"
              id="last_name"
              formControlName="last_name"
              [ngClass]="{'is-invalid': submitted && f['last_name'].errors}"
            >
            <div class="invalid-feedback" *ngIf="submitted && f['last_name'].errors">
              <div *ngIf="f['last_name'].errors['required']">Apellido es requerido</div>
              <div *ngIf="f['last_name'].errors['last_name']">Apellido debe ser válido</div>
            </div>
          </div>

          <div class="form-group required mb-3" *ngIf="!user">
            <label for="phone" class="form-label">Teléfono</label>
            <input 
              type="phone"
              class="form-control"
              id="phone"
              formControlName="phone"
              [ngClass]="{'is-invalid': submitted && f['phone'].errors}"
            >
            <div class="invalid-feedback" *ngIf="submitted && f['phone'].errors">
              <div *ngIf="f['phone'].errors['required']">Teléfono es requerido</div>
              <div *ngIf="f['phone'].errors['phone']">Teléfono debe ser válido</div>
            </div>
          </div>


          <div class="form-group required mb-3" *ngIf="!user">
            <label for="email" class="form-label">Correo electrónico</label>
            <input 
              type="email"
              class="form-control"
              id="email"
              formControlName="email"
              [ngClass]="{'is-invalid': submitted && f['email'].errors}"
            >
            <div class="invalid-feedback" *ngIf="submitted && f['email'].errors">
              <div *ngIf="f['email'].errors['required']">Correo electrónico es requerido</div>
              <div *ngIf="f['email'].errors['email']">Correo electrónico debe ser válido</div>
            </div>
          </div>

          <div class="form-group required mb-3">
            <label for="role" class="form-label">Rol</label>
            <select 
              class="form-select" 
              id="role" 
              formControlName="role"
              [ngClass]="{'is-invalid': submitted && f['role'].errors}"
            >
              <option value="">Selecciona un rol</option>
              <option 
                *ngFor="let roleOption of roleOptions" 
                [value]="roleOption.value"
                [disabled]="isRoleDisabled(roleOption.value)"
              >
                {{roleOption.label}}
              </option>
            </select>
            <div class="invalid-feedback" *ngIf="submitted && f['role'].errors">
              <div *ngIf="f['role'].errors['required']">Rol es requerido</div>
            </div>
          </div>

          <div class="d-flex justify-content-end gap-2 mt-4">
            <button type="button" class="btn btn-outline-secondary" (click)="onCancel()">Cancelar</button>
            <button type="submit" class="btn btn-primary" [disabled]="loading">
              <span *ngIf="loading" class="spinner-border spinner-border-sm me-1" role="status" aria-hidden="true"></span>
              {{ user ? 'Actualizar' : 'Crear' }}
            </button>
          </div>
        </form>
      </div>
    </ng-template>
  `,
  styles: ``
})
export class UsersFormComponent implements OnInit {
  @Input() settlement: Settlement | null = null;
  @Input() user: SettlementUser | null = null;
  @Output() formSubmitted = new EventEmitter<boolean>();
  @Output() formCancelled = new EventEmitter<void>();
  @ViewChild('usersForm') usersForm !: ElementRef;

  userForm: FormGroup;
  submitted = false;
  loading = false;
  
  // Available roles for the dropdown
  roleOptions = [
    { value: 'admin', label: 'Administrador' },
    { value: 'operation', label: 'Operación' },
    { value: 'billing', label: 'Facturación' }
  ];

  // Store existing roles to prevent duplicates
  existingRoles: string[] = [];

  private modalRef: NgbModalRef | undefined;

  constructor(
    private formBuilder: FormBuilder,
    private store: SettlementsService,
    private toastr: ToastrService,
    private modalService: NgbModal,
  ) {
    this.userForm = this.formBuilder.group({
      name: ['', Validators.required],
      last_name: ['', Validators.required],
      phone: ['', [Validators.required, Validators.pattern(/^\+?[0-9\s]+$/)]],
      email: ['', [Validators.required, Validators.email]],
      role: ['', Validators.required]
    });
  }

  ngOnInit(): void {
    // Load existing roles to prevent duplicates
    
  }

  loadRoles(): void {
    /*this.store.getSettlementUsers(Number(this.settlement?.id)).subscribe(users => {
      this.existingRoles = users
        .filter(u => u.id !== this.user?.id) // Don't include the current user's role
        .map(u => u.role);
      
      // If editing, populate the form
      if (this.user) {
        this.userForm.patchValue({
          role: this.user.role
        });
        // Remove the email control if we're editing
        this.userForm.removeControl('email');
      }
    });*/
  }

  // Check if a role should be disabled (already assigned to another user)
  isRoleDisabled(role: string): boolean {
    return this.existingRoles.includes(role);
  }

  // Getter for easy access to form fields
  get f() { 
    return this.userForm.controls; 
  }

  onSubmit(): void {
    this.submitted = true;
    
    if (this.userForm.invalid) {
      return;
    }
    
    this.loading = true;
    
    if (this.user) {
      // Update existing user
      this.store.updateSettlementUser(
        Number(this.settlement?.id),
        this.user.id!, 
        { role: this.userForm.value.role }
      ).subscribe({
        next: () => {
          this.toastr.success('Usuario actualizado correctamente', 'Éxito');
          this.formSubmitted.emit(true);
          this.loading = false;
        },
        error: (error) => {
          this.toastr.error('Error al actualizar usuario', 'Error');
          this.loading = false;
        }
      });
    } else {
      // Create new user
      this.store.createSettlementUser(
        Number(this.settlement?.id), 
        { 
          user: { 
            name: this.userForm.value.name,
            last_name: this.userForm.value.last_name,
            phone: this.userForm.value.phone,
            email: this.userForm.value.email 
          }, 
          role: this.userForm.value.role 
        }
      ).subscribe({
        next: () => {
          this.toastr.success('Usuario creado correctamente', 'Éxito');
          this.formSubmitted.emit(true);
          this.loading = false;
        },
        error: (error) => {
          this.toastr.error('Error al crear usuario', 'Error');
          this.loading = false;
        }
      });
    }
  }

  onCancel(): void {
    this.formCancelled.emit();
  }

  openModal(modalContent: TemplateRef<any>) {
      this.modalRef = this.modalService.open(modalContent);
      this.loadRoles();
  }

  dismiss() {
    if (this.modalRef) {
      this.modalRef.dismiss();
    }
  }
}
